/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_Included_5Inputs */

const tr_landing_pricing_included_5 = /** @type {(inputs: Landing_Pricing_Included_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veri dışa aktarımı`)
};

const en_landing_pricing_included_5 = /** @type {(inputs: Landing_Pricing_Included_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data export`)
};

const de_landing_pricing_included_5 = /** @type {(inputs: Landing_Pricing_Included_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datenexport`)
};

const ru_landing_pricing_included_5 = /** @type {(inputs: Landing_Pricing_Included_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экспорт данных`)
};

/**
* | output |
* | --- |
* | "Data export" |
*
* @param {Landing_Pricing_Included_5Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_pricing_included_5 = /** @type {((inputs?: Landing_Pricing_Included_5Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_Included_5Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricing_included_5(inputs)
	if (locale === "de") return de_landing_pricing_included_5(inputs)
	if (locale === "ru") return ru_landing_pricing_included_5(inputs)
	return tr_landing_pricing_included_5(inputs)
});